import axios from "axios";
import qs from "qs";

axios.defaults.timeout = 30000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
// 腕上健康
// axios.defaults.baseURL = 'https://www01.lantianfangzhou.com/r5s/init/'

// 生命监护
// axios.defaults.baseURL = 'https://rulong.lantianfangzhou.com/all/public/api/init/'

// 生命监护最新地址
// axios.defaults.baseURL = 'https://test02.lantianfangzhou.com/api/init'

// 腕上健康测试--2019-8-2
// axios.defaults.baseURL = 'http://test12.lantianfangzhou.com/api/init/'

// POST传参序列化
axios.interceptors.request.use(
  config => {
    if (config.method === "post") {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }     
);

// 返回状态判断
axios.interceptors.response.use(
  res => {
    if (res.data.code === 2001) {
      return Promise.reject(res);
    }

    return res;
  },
  error => {
    // 其他错误，如404
    return Promise.reject(error);
  }
);


export function fetch(appType, url, params) {
  return new Promise((resolve, reject) => {
    let baseUrl = "";
    if (appType.appName === "smjh") {
      baseUrl = "https://test02.lantianfangzhou.com/api/init";
    } else {
    
        baseUrl = "https://tcp.zcjk9.com/init";
    }
    axios
      .post(baseUrl + url, params)
      .then(
        response => {
          resolve(response.data);
        },
        err => {
          reject(err);
        }
      )
      .catch(error => {
        reject(error);
      });
  });
}



/**
 * 业务逻辑，个组件调用相应方法
 */

export default {


  getCurrentInit(type, params) {
    //
    return fetch(type, "/headimg", params);
  },



  getCurrentWarn(type, params) {
    // 当前心率预警
    return fetch(type, "/warning", params);
  },


  //   getCurrentHomePage(type, params) {
  //   // 首页九宫格
  //   return fetch(type, "/homepage", params);
  // },

  // //8度体验
  getCurrentHomePage(type, params) {
     // 首页九宫格
     return fetch(type, "/homepagelink", params);
   },

  getCurrentHeartrate(type, params) {
    // 心率详情
    return fetch(type, "/heartrate", params);
  },
  getCurrentBloodpressure(type, params) {
    // 血压详情
    return fetch(type, "/bloodpressure", params);
  },
  getCurrentBloodsugar(type, params) {
    // 血糖详情
    return fetch(type, "/bloodsugar", params);
  },
     getCurrentNiaosuan(type, params) {
      // 尿酸详情
      return fetch(type, "/niaosuan", params);
    },
  getCurrentSp(type, params) {
    // 血氧详情
    return fetch(type, "/sp", params);
  },
  getCurrentTemperature(type, params) {
    // 体温详情
    return fetch(type, "/temperature", params);
  },
  getCurrentViscera(type, params) {
    // 脏腑详情
    return fetch(type, "/viscera", params);
  },
  getCurrentCardiopulmonary(type, params) {
    // 心肺详情
    return fetch(type, "/cardiopulmonary", params);
  },
  getCurrentUsersleep(type, params) {
    // 睡眠详情
    return fetch(type, "/usersleep", params);
  },
  // getCurrentUsersleep(type, params) {
  //   // 睡眠详情
  //   return fetch(type, "/usersleeplink", params);
  // },
  getCurrentFatiguemonitoring(type, params) {
    // 疲劳详情
    return fetch(type, "/fatiguemonitoring", params);
  },
  getCurrentSteps(type, params) {
    // 运动详情
    return fetch(type, "/steps", params);
  },
  getOnlineHeartRate(type, params) {
    // 心律检测
    return fetch(type, "/manualrate", params);
  },

  remodeOnlineHeart(type, params) {
    return fetch(type, "/deletehrhy", params);
  },



  getDayDateStart(type, params) {
    // 日报数据上下限制
    return fetch(type, "/datestart", params);
  },

  // 日历
  getCalendar(type, params) {
    return fetch(type, "/getcalendar", params);
  },

  // 日报心率
  getDayheartrate(type, params) {
    return fetch(type, "/dayheartrate", params);
  },
  // 日报预警
  getDaywarn(type, params) {
    return fetch(type, "/daywarning", params);
  },
  // 日报血压
  getDaybloodpressure(type, params) {
    return fetch(type, "/daybp", params);
  },
  // 日报血糖
  getDaybloodsugar(type, params) {
    return fetch(type, "/daybs", params);
  },
  // 日报血氧
  getDaybloodoxygen(type, params) {
    return fetch(type, "/daysp", params);
  },
  // 日报体温
  getDaybodytempera(type, params) {
    return fetch(type, "/daytem", params);
  },
  // 日报脏腑
  getDayviscera(type, params) {
    return fetch(type, "/dayvis", params);
  },
  // 日报心肺
  getDayheartlung(type, params) {
    return fetch(type, "/daycar", params);
  },
  // 日报睡眠
  getDaysleep(type, params) {
    return fetch(type, "/dayusersleep", params);
  },

   // 日报睡眠
  // getDaysleep(type, params) {
  //   return fetch(type, "/dayusersleeplink", params);
  // },
  // 日报疲劳
  getDayweary(type, params) {
    return fetch(type, "/dayfat", params);
  },


  // 日报运动
  getDaysports(type, params) {
    return fetch(type, "/daysteps", params);
  },












  // 周报默认周期值周报开始周报开始周报开始周报开始
  getWeekdefault(type, params) {
    return fetch(type, "/weekstart", params);
  },
  // 周报列表
  getWeeklist(type, params) {
    return fetch(type, "/datelist", params);
  },
  // 周报心率
  getWeekheartrate(type, params) {
    return fetch(type, "/weekheartrate", params);
  },
  // 周报血压
  getWeekbloodpressure(type, params) {
    return fetch(type, "/weekbp", params);
  },
  // 周报血糖
  getWeekbloodsugar(type, params) {
    return fetch(type, "/weekbs", params);
  },
  // 周报血氧
  getWeekbloodoxygen(type, params) {
    return fetch(type, "/weeksp", params);
  },
  // 周报体温
  getWeekbodytempera(type, params) {
    return fetch(type, "/weektem", params);
  },
  // 周报脏腑
  getWeekviscera(type, params) {
    return fetch(type, "/weekvis", params);
  },
  // 周报心肺
  getWeekheartlung(type, params) {
    return fetch(type, "/weekcar", params);
  },
  // // 周报睡眠
  getWeeksleep(type, params) {
    return fetch(type, "/weekusersleep", params);
  },
   // 周报睡眠
  // getWeeksleep(type, params) {
  //   return fetch(type, "/weekusersleeplink", params);
  // },
  // 周报疲劳
  getWeekweary(type, params) {
    return fetch(type, "/weekfat", params);
  },
  // 周报运动
  getWeeksports(type, params) {
    return fetch(type, "/weekstps", params);
  },



  // 月报默认周期值月报开始月报开始月报开始月报开始
  getMonthdefault(type, params) {
    return fetch(type, "/monthstart", params);
  },
  // 月报列表
  getMonthlist(type, params) {
    return fetch(type, "/monthlist", params);
  },
  // 月报心率
  getMonthheartrate(type, params) {
    return fetch(type, "/monthheartrate", params);
  },
  // 月报血压
  getMonthbloodpressure(type, params) {
    return fetch(type, "/monthbp", params);
  },
  // 月报血糖
  getMonthbloodsugar(type, params) {
    return fetch(type, "/monthbs", params);
  },
  // 月报血氧
  getMonthbloodoxygen(type, params) {
    return fetch(type, "/monthsp", params);
  },
  // 月报体温
  getMonthbodytempera(type, params) {
    return fetch(type, "/monthtem", params);
  },
  // 月报脏腑
  getMonthviscera(type, params) {
    return fetch(type, "/monthvis", params);
  },
  // 月报心肺
  getMonthheartlung(type, params) {
    return fetch(type, "/monthcar", params);
  },
  // 月报睡眠
  getMonthsleep(type, params) {
    return fetch(type, "/monthusersleep", params);
  },
    // 月报睡眠
  // getMonthsleep(type, params) {
  //   return fetch(type, "/monthusersleeplink", params);
  // },
  // 月报疲劳
  getMonthweary(type, params) {
    return fetch(type, "/monthfat", params);
  },
  // 月报运动
  getMonthsports(type, params) {
    return fetch(type, "/monthsteps", params);
  },



  // 年报默认周期值年报开始年报开始年报开始年报开始
  getYeardefault(type, params) {
    return fetch(type, "/yearstart", params);
  },
  // 年报列表
  getYearlist(type, params) {
    return fetch(type, "/yearlist", params);
  },
  // 年报心率
  getYearheartrate(type, params) {
    return fetch(type, "/yearheartrate", params);
  },
  // 年报血压
  getYearbloodpressure(type, params) {
    return fetch(type, "/yearbp", params);
  },
  // 年报血糖
  getYearbloodsugar(type, params) {
    return fetch(type, "/yearbs", params);
  },
  // 年报血氧
  getYearbloodoxygen(type, params) {
    return fetch(type, "/yearsp", params);
  },
  // 年报体温
  getYearbodytempera(type, params) {
    return fetch(type, "/yeartem", params);
  },
  // 年报脏腑
  getYearviscera(type, params) {
    return fetch(type, "/yearvis", params);
  },
  // 年报心肺
  getYearheartlung(type, params) {
    return fetch(type, "/yearcar", params);
  },
  // 年报睡眠
  getYearsleep(type, params) {
    return fetch(type, "/yearusersleep", params);
  },
    // 年报睡眠
  // getYearsleep(type, params) {
  //   return fetch(type, "/yearusersleeplink", params);
  // },
  // 年报疲劳
  getYearweary(type, params) {
    return fetch(type, "/yearfat", params);
  },
  // 年报运动
  getYearsports(type, params) {
    return fetch(type, "/yearsteps", params);
  },

  // 位置信息
  getMap(type, params) {
    return fetch(type, "/address", params);
  },

 //呼吸周
  breathWeek(type, params) {
    return fetch(type, "/weekbreath", params);
  },
   //呼吸月
  breathMonth(type, params) {
    return fetch(type, "/monthbreath", params);
  },
   //呼吸年
  breathYear(type, params) {
    return fetch(type, "/yearbreath", params);
  },
  //呼吸
  getCurrentBreathe(type, params) {
    return fetch(type, "/breathing", params);
  },
  //日报呼吸
  getDayBreathe(type, params) {
    return fetch(type, "/daybrath", params);
  },
   // 心电
  getEcg(type, params) {
    return fetch(type, "/ecg", params);
  }


};



// WEBPACK FOOTER //
// ./src/axios/index.js